import React from 'react';

import { MonitoringContainer } from '../../containers';

export const Monitoring: React.FC = () => <MonitoringContainer />;
